import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation  } from "react-router-dom";
import { createAgent, updateAgent } from "services/AgentService";

const AgentForm = () => {
  const [formData, setFormData] = useState({
    agent_name: "",
    company_name: "",
    billing_address: "",
    contact_number: "",
    email: "",
    state: "",
    city: "",
    gst_number: "",
  });

   const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);  
    const navigate = useNavigate();
    const location = useLocation();
  
    const { isEdit, editFormData } = location.state || { isEdit: false, editFormData: {} };
  
    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData({ ...formData, [name]: value });
    };
    
  
    useEffect(() => {
      if (isEdit && editFormData) {       
        setFormData(editFormData);       
      }
    }, [isEdit, editFormData]);
  
    const handleSubmit = async (e) => {
      e.preventDefault();
      try {
        const newErrors = validate();
        if (Object.keys(newErrors).length > 0) {
          setErrors(newErrors);
        } else {
          setErrors({});
          setLoading(true);
         
          let response;
          if(isEdit)
          {
             response = await updateAgent(formData);
          }else{
             response = await createAgent(formData);
          }
          
          setLoading(false);
          if (response?.data?.success) {
            navigate("/agents");
          } else if (response?.data?.errors) {
          
            const serverErrors = {};
            for (const field in response.data.errors) {
              serverErrors[field] = response.data.errors[field][0]; 
            }
            setErrors(serverErrors);
          }
        }
      } catch (error) {
        console.error("Error adding agent:", error);
      }
    };
  
    const validate = () => {
      const newErrors = {};
      if (!formData.agent_name) {
        newErrors.agent_name = "Name is required";
      }
      if (!formData.email) {
        newErrors.email = "Email is required";
      }
     
      return newErrors;
    };

  return (
    <>
      <section className="content-header">
        <div className="header-icon">
          <i className="fa fa-users"></i>
        </div>
        <div className="header-title">
          <h1>Add Agent</h1>
          <small>Add New Agent</small>
        </div>
      </section>
      <section className="content">
        <div className="row">
          <div className="col-sm-12">
            <div
              className="card lobicard all_btn_card"
              id="lobicard-custom-control1"
              data-sortable="true"
            >
              <div className="card-header all_card_btn">
                <div className="card-title custom_title">
                  <Link className="btn btn-add" to="/agents">
                    <i className="fa fa-list"></i> Agents List{" "}
                  </Link>
                </div>
              </div>
              <div className="card-body">
                <form className="col-sm-12" onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label>Agent Name</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Agent Name"
                        name="agent_name"
                        value={formData.agent_name}
                        onChange={handleChange}
                        required
                      />
                      {errors.agent_name && (
                      <small className="text-danger">{errors.agent_name}</small>
                    )}
                    </div>

                    <div className="col-md-6 mb-3">
                      <label>Company Name</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Company Name"
                        name="company_name"
                        value={formData.company_name}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <label>Billing Address</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Billing Address"
                        name="billing_address"
                        value={formData.billing_address}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <label>Contact Number</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Person Name"
                        name="contact_number"
                        value={formData.contact_number}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <label>Email ID</label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Enter Email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                      {errors.email && (
                      <small className="text-danger">{errors.email}</small>
                    )}
                    </div>

                  {/*  <div className="col-md-6 mb-3">
                      <label>State</label>
                      <select
                        className="form-control"
                        name="state"
                        value={formData.state}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select State</option>
                        <option value="Andhra Pradesh">Andhra Pradesh</option>
                        <option value="Arunachal Pradesh">Arunachal Pradesh</option>
                        <option value="Assam">Assam</option>
                        <option value="Bihar">Bihar</option>
                        <option value="Chhattisgarh">Chhattisgarh</option>
                        <option value="Goa">Goa</option>
                        <option value="Gujarat">Gujarat</option>
                        <option value="Haryana">Haryana</option>
                        <option value="Himachal Pradesh">Himachal Pradesh</option>
                        <option value="Jharkhand">Jharkhand</option>
                        <option value="Karnataka">Karnataka</option>
                        <option value="Kerala">Kerala</option>
                        <option value="Madhya Pradesh">Madhya Pradesh</option>
                        <option value="Maharashtra">Maharashtra</option>
                        <option value="Manipur">Manipur</option>
                        <option value="Meghalaya">Meghalaya</option>
                        <option value="Mizoram">Mizoram</option>
                        <option value="Nagaland">Nagaland</option>
                        <option value="Odisha">Odisha</option>
                        <option value="Punjab">Punjab</option>
                        <option value="Rajasthan">Rajasthan</option>
                        <option value="Sikkim">Sikkim</option>
                        <option value="Tamil Nadu">Tamil Nadu</option>
                        <option value="Telangana">Telangana</option>
                        <option value="Tripura">Tripura</option>
                        <option value="Uttar Pradesh">Uttar Pradesh</option>
                        <option value="Uttarakhand">Uttarakhand</option>
                        <option value="West Bengal">West Bengal</option>
                        <option value="Andaman and Nicobar Islands">Andaman and Nicobar Islands</option>
                        <option value="Chandigarh">Chandigarh</option>
                        <option value="Dadra and Nagar Haveli and Daman and Diu">Dadra and Nagar Haveli and Daman and Diu</option>
                        <option value="Delhi">Delhi</option>
                        <option value="Jammu and Kashmir">Jammu and Kashmir</option>
                        <option value="Ladakh">Ladakh</option>
                        <option value="Lakshadweep">Lakshadweep</option>
                        <option value="Puducherry">Puducherry</option>
                      </select>
                    </div>

                    <div className="col-md-6 mb-3">
                      <label>Select City</label>
                      <select
                        className="form-control"
                        name="city"
                        value={formData.city}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select City</option>
                        <option value="Delhi">Delhi</option>
                        <option value="Nainital">Nainital</option>
                        <option value="Manali">Manali</option>
                        <option value="Amritsar">Amritsar</option>
                      </select>
                    </div> */}

                    <div className="col-md-6 mb-3">
                      <label>GST Number</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter GST Number"
                        name="gst_number"
                        value={formData.gst_number}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="reset-button">
                   <button type="submit" className="btn btn-success" disabled={loading}>
                      {loading ? "Saving..." : "Save"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AgentForm;
